<div class="news-card">
  <img [src]="imageUrl" alt="news" />
  <div class="news-card__content flex-col justify-between">
    <div>
      <time>{{ date | date : "longDate" }}</time>
      <app-action-menu
        [isOpen]="index === menuOpenIndex"
        (delete)="onDeleteNews()"
        (edit)="handleEditNews(id)"
        (outsideClick)="closeAllMenu()"
        (open)="openMenu()"
      ></app-action-menu>
    </div>
    <div>
      <div class="news-card__tags flex-wrap">
        <span *ngFor="let tag of tags">{{ tag }}</span>
      </div>
      <h2>{{ title }}</h2>
    </div>
  </div>
</div>
